import { BUSINESS_TOOL_SECTIONS, BUSINESS_TOOL_SUB_SECTIONS } from 'constants/businessTool';

import { GENDER_OPTIONS } from 'components/BusinessToolForm/constants/options';

export const prefix =
  `${BUSINESS_TOOL_SECTIONS.MARKET_ANALYSIS}.${BUSINESS_TOOL_SUB_SECTIONS.MARKET_ANALYSIS.CONSUMER_NEEDS}` as const;

export const B2C_PREFIX =
  `${BUSINESS_TOOL_SECTIONS.MARKET_ANALYSIS}.${BUSINESS_TOOL_SUB_SECTIONS.MARKET_ANALYSIS.CONSUMER_NEEDS}.B2C` as const;

export const B2B_PREFIX =
  `${BUSINESS_TOOL_SECTIONS.MARKET_ANALYSIS}.${BUSINESS_TOOL_SUB_SECTIONS.MARKET_ANALYSIS.CONSUMER_NEEDS}.B2B` as const;

export const CONSUMER_NEEDS_NAMES = {
  INFLUENCING_FACTORS: 'influencingFactors',
  DIFFERENCES: 'differences',
  HOW_CUSTOMERS_SATISFIED: 'howCustomersSatisfied',
  DEMAND: 'demand',
  CUSTOMER_BASE_SIZE: 'customerBaseSize',
  SURVEY: 'survey',
  PURCHASING_DECISION: 'purchasingDecision',
  B2C: 'B2C',
  B2B: 'B2B',
} as const;

export const B2B_NAMES = {
  ANNUAL_REVENUE: 'annualRevenue',
  INDUSTRY: 'industry',
  NUMBER_OF_EMPLOYERS: 'numberOfEmployers',
  PURCHASING_CYCLE: 'customerBuyingBehavior',
  REGION: 'region',
} as const;

export const B2C_NAMES = {
  GENDER: 'stage',
  AGE: 'age',
  ANNUAL_INCOME: 'annualIncome',
  NEEDS_AND_PROBLEMS: 'needsAndProblems',
  PERSONAL_INTERESTS: 'personalInterests',
  PROFESSION: 'profession',
  PURCHASING_HABITS: 'purchasingHabits',
} as const;

export interface IB2B {
  [B2B_NAMES.ANNUAL_REVENUE]: string;
  [B2B_NAMES.INDUSTRY]: string;
  [B2B_NAMES.NUMBER_OF_EMPLOYERS]: string;
  [B2B_NAMES.PURCHASING_CYCLE]: string;
  [B2B_NAMES.REGION]: string;
}

export interface IB2C {
  [B2C_NAMES.GENDER]: string | { value: string; label: string };
  [B2C_NAMES.AGE]: string;
  [B2C_NAMES.ANNUAL_INCOME]: string;
  [B2C_NAMES.NEEDS_AND_PROBLEMS]: string;
  [B2C_NAMES.PERSONAL_INTERESTS]: string;
  [B2C_NAMES.PROFESSION]: string;
  [B2C_NAMES.PURCHASING_HABITS]: string;
}

export interface IConsumerNeeds {
  [CONSUMER_NEEDS_NAMES.B2C]: IB2C;
  [CONSUMER_NEEDS_NAMES.B2B]: IB2B;
  [CONSUMER_NEEDS_NAMES.INFLUENCING_FACTORS]: string;
  [CONSUMER_NEEDS_NAMES.DIFFERENCES]: string;
  [CONSUMER_NEEDS_NAMES.HOW_CUSTOMERS_SATISFIED]: string;
  [CONSUMER_NEEDS_NAMES.DEMAND]: string;
  [CONSUMER_NEEDS_NAMES.CUSTOMER_BASE_SIZE]: string;
  [CONSUMER_NEEDS_NAMES.SURVEY]: string;
  [CONSUMER_NEEDS_NAMES.PURCHASING_DECISION]: string;
}

export const consumerNeedsInitialValues = {
  [CONSUMER_NEEDS_NAMES.INFLUENCING_FACTORS]: '',
  [CONSUMER_NEEDS_NAMES.DIFFERENCES]: '',
  [CONSUMER_NEEDS_NAMES.HOW_CUSTOMERS_SATISFIED]: '',
  [CONSUMER_NEEDS_NAMES.DEMAND]: '',
  [CONSUMER_NEEDS_NAMES.CUSTOMER_BASE_SIZE]: '',
  [CONSUMER_NEEDS_NAMES.SURVEY]: '',
  [CONSUMER_NEEDS_NAMES.PURCHASING_DECISION]: '',
  [CONSUMER_NEEDS_NAMES.B2B]: {
    [B2B_NAMES.INDUSTRY]: '',
    [B2B_NAMES.ANNUAL_REVENUE]: '',
    [B2B_NAMES.NUMBER_OF_EMPLOYERS]: '',
    [B2B_NAMES.REGION]: '',
    [B2B_NAMES.PURCHASING_CYCLE]: '',
  },
  [CONSUMER_NEEDS_NAMES.B2C]: {
    [B2C_NAMES.GENDER]: GENDER_OPTIONS[0],
    [B2C_NAMES.AGE]: '',
    [B2C_NAMES.ANNUAL_INCOME]: '',
    [B2C_NAMES.NEEDS_AND_PROBLEMS]: '',
    [B2C_NAMES.PERSONAL_INTERESTS]: '',
    [B2C_NAMES.PROFESSION]: '',
    [B2C_NAMES.PURCHASING_HABITS]: '',
  },
};
